<template>
  <div class="flex flex-1 flex-grow flex-col justify-between pb-4">
    <div class="flex flex-1 items-center justify-center">
      <h3 class="text-text-neutral-primary text-lg font-semibold">
        {{ $t('ancillaries.seatMap.noSeatMapForSegment.title') }}
      </h3>
    </div>
    <slot></slot>
  </div>
</template>
